div.section-footer {
  background-color: var(--rds-body-color-background-subtle);
  box-sizing: border-box;
  padding: var(--rds-padding-300) var(--rds-padding-150);
  --rds-button-font-weight: var(--rds-paragraph-font-weight);
  --rds-button-padding-left: 16px;
  --rds-button-padding-right: 16px;
}

.signing-method-button rds-button {
  width: 100%;
  font-size: var(--rds-font-size-md);
  font-weight: var(--rds-font-weight-normal);
  box-sizing: content-box;
}

.button-content {
  flex-wrap: wrap;
  align-items: center;
  width: calc(100vw - var(--rds-padding-150) * 2);
}

.signing-method-button {
  width: 100%;
}

.section-method-switch {
  flex-wrap: wrap;
}
@media (min-width: 576px) {
  .signing-method-button {
    width: auto;
  }

  .button-content {
    width: 290px;
  }

  .signing-method-button rds-button {
    width: 290px;
    margin-left: 16px;
    margin-right: 16px;
  }
}
